(() => {
  const key = 'moebe-wishlist-v1';
  const dialog = document.getElementById('MoebeWishlist');
  const stringsElement = document.getElementById('MoebeWishlistStrings');
  if (!dialog || !stringsElement) return;
  const strings = JSON.parse(stringsElement.textContent);
  const status = document.querySelector('[data-moebe-wishlist-status]');
  const list = dialog.querySelector('[data-moebe-wishlist-list]');
  let items = [];
  const addingIds = new Set();
  try {
    const saved = JSON.parse(localStorage.getItem(key) || '[]');
    if (Array.isArray(saved)) items = saved.filter(item => item && item.id && typeof item.handle === 'string' && /^[a-z0-9-]+$/.test(item.handle)).slice(0,200);
  } catch (_) {}
  const announce = text => { status.textContent = text; };
  const currency = () => window.Shopify?.currency?.active || document.querySelector('[data-moebe-wishlist-product]')?.dataset.currency || 'EUR';
  function money(cents, code) {
    const value = Number(cents) / 100;
    const number = new Intl.NumberFormat(code === 'DKK' ? 'da-DK' : 'en-GB', { maximumFractionDigits: value % 1 ? 2 : 0 }).format(value);
    if (code === 'EUR') return '€' + number;
    if (code === 'GBP') return '£' + number;
    if (code === 'DKK') return number + ' kr';
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:code}).format(value);
  }
  function selected(wrapper) {
    const variants = JSON.parse(wrapper.querySelector('[data-moebe-wishlist-variants]').textContent);
    const form = document.getElementById(wrapper.dataset.formId);
    const id = form?.querySelector('[name="id"]')?.value || wrapper.dataset.variantId;
    return variants.find(v => String(v.id) === String(id));
  }
  function sync() {
    document.querySelectorAll('[data-moebe-wishlist-product]').forEach(wrapper => {
      const variant = selected(wrapper);
      const saved = variant && items.some(item => String(item.id) === String(variant.id));
      wrapper.querySelector('[data-moebe-wishlist-save]').setAttribute('aria-pressed', String(Boolean(saved)));
      wrapper.querySelector('[data-moebe-wishlist-label]').textContent = saved ? strings.added : strings.add;
    });
  }
  function persist(next) {
    try { localStorage.setItem(key, JSON.stringify(next)); }
    catch (_) { announce(strings.error); return false; }
    items = next; sync(); return true;
  }
  function safeImage(src) {
    if (!src) return '';
    try { const url = new URL(src, location.origin); return url.protocol === 'https:' ? url.href : ''; }
    catch (_) { return ''; }
  }
  function productUrl(item) {
    const root = window.Shopify?.routes?.root || '/';
    return root + 'products/' + encodeURIComponent(item.handle) + '?variant=' + encodeURIComponent(item.id);
  }
  function render() {
    list.replaceChildren();
    dialog.querySelector('[data-moebe-wishlist-empty]').hidden = items.length > 0;
    items.forEach(item => {
      const row = document.createElement('div'); row.className = 'moebe-wishlist-item';
      const imageLink = document.createElement('a'); imageLink.href = productUrl(item); imageLink.setAttribute('aria-label',item.title);
      const src = safeImage(item.image);
      if (src) { const image = document.createElement('img'); image.src = src; image.alt = item.title; image.loading = 'lazy'; imageLink.append(image); }
      const details = document.createElement('div');
      const title = document.createElement('a'); title.href = productUrl(item); title.textContent = item.title;
      details.append(title);
      if (item.variantTitle && item.variantTitle !== 'Default Title') { const variant = document.createElement('p'); variant.textContent = item.variantTitle; details.append(variant); }
      if (!item.contract && item.currency === currency()) { const price = document.createElement('p'); price.textContent = money(item.price,item.currency); details.append(price); }
      const actions = document.createElement('div'); actions.className = 'moebe-wishlist-actions';
      const feedback = document.createElement('p'); feedback.className = 'moebe-wishlist-feedback'; feedback.setAttribute('role', 'status'); feedback.hidden = true;
      if (!item.contract) {
        const addToCart = document.createElement('button'); addToCart.type = 'button';
        addToCart.textContent = addingIds.has(String(item.id)) ? strings.cartAdding : strings.cartAdd;
        addToCart.disabled = addingIds.has(String(item.id));
        addToCart.setAttribute('aria-label', strings.cartAdd + ': ' + item.title + (item.variantTitle && item.variantTitle !== 'Default Title' ? ' — ' + item.variantTitle : ''));
        addToCart.addEventListener('click', async () => {
          const id = String(item.id);
          if (addingIds.has(id)) return;
          addingIds.add(id); addToCart.disabled = true; addToCart.textContent = strings.cartAdding; feedback.hidden = true;
          let product;
          let added = false;
          try {
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(root + 'cart/add.js', {
              method: 'POST', credentials: 'same-origin',
              headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
              body: JSON.stringify({id: item.id, quantity: 1})
            });
            product = await response.json();
            if (!response.ok || product.status) throw new Error(product.description || product.message || strings.cartError);
            added = true;
          } catch (error) {
            feedback.textContent = error.message || strings.cartError; feedback.hidden = false;
          } finally {
            addingIds.delete(id); addToCart.disabled = false; addToCart.textContent = strings.cartAdd;
          }
          if (added) {
            announce(strings.cartAdded);
            dialog.close();
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {detail: {product, addToCartBtn: addToCart}}));
          }
        });
        actions.append(addToCart);
      }
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = strings.remove; remove.setAttribute('aria-label', strings.remove + ': ' + item.title);
      remove.addEventListener('click',()=>{ if (persist(items.filter(saved => String(saved.id) !== String(item.id)))) { render(); announce(strings.removed); const next = list.querySelector('button'); (next || dialog.querySelector('[data-moebe-wishlist-close]')).focus(); } });
      actions.append(remove); details.append(actions, feedback); row.append(imageLink,details); list.append(row);
    });
  }
  async function refresh() {
    const root = window.Shopify?.routes?.root || '/';
    await Promise.allSettled(items.map(async item => {
      const response = await fetch(root + 'products/' + encodeURIComponent(item.handle) + '.js');
      if (!response.ok) return;
      const product = await response.json();
      const variant = product.variants.find(v => String(v.id) === String(item.id));
      if (!variant) return;
      item.price = variant.price; item.currency = currency(); item.title = product.title;
      item.variantTitle = variant.title; item.image = variant.featured_image?.src || product.featured_image || item.image;
    }));
    if (dialog.open) render();
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-moebe-wishlist-open]');
    if (opener) { render(); if (!dialog.open) dialog.showModal(); refresh(); return; }
    const save = event.target.closest('[data-moebe-wishlist-save]');
    if (!save) return;
    const wrapper = save.closest('[data-moebe-wishlist-product]');
    const variant = selected(wrapper);
    if (!variant) { announce(strings.unavailable); return; }
    const exists = items.some(item => String(item.id) === String(variant.id));
    const item = {id:variant.id,handle:wrapper.dataset.productHandle,title:wrapper.dataset.productTitle,variantTitle:variant.title,price:variant.price,currency:wrapper.dataset.currency,image:variant.featured_image?.src || JSON.parse(wrapper.querySelector('[data-moebe-wishlist-image]').textContent),contract:wrapper.dataset.contract === 'true'};
    const next = exists ? items.filter(item => String(item.id) !== String(variant.id)) : [...items,item];
    if (persist(next)) announce(exists ? strings.removed : strings.added);
  });
  dialog.querySelector('[data-moebe-wishlist-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
  document.addEventListener('variant:change',sync);
  document.addEventListener('change',()=>setTimeout(sync,0));
  document.addEventListener('shopify:section:load',sync);
  window.addEventListener('storage',event=>{ if (event.key === key) { try { const value = JSON.parse(event.newValue || '[]'); items = Array.isArray(value) ? value : []; sync(); if (dialog.open) render(); } catch (_) {} } });
  sync();
})();
